/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import { HttpClient } from "./http-client";
export class Tokens extends HttpClient {
    /**
     * No description
     *
     * @tags Tokens
     * @name TokenControllerMockGuard
     * @summary Just a mock method to check TenantId decorator
     * @request GET:/tokens/mock
     * @secure
     */
    tokenControllerMockGuard = (params = {}) => this.request({
        path: `/tokens/mock`,
        method: "GET",
        secure: true,
        ...params,
    });
    /**
     * No description
     *
     * @tags Tokens
     * @name TokenControllerCreateToken
     * @summary Create a new token for a tenant with specified name and grants
     * @request POST:/tokens
     * @secure
     */
    tokenControllerCreateToken = (data, params = {}) => this.request({
        path: `/tokens`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
    });
    /**
     * No description
     *
     * @tags Tokens
     * @name TokenControllerListTokens
     * @summary List all tokens for the current tenant
     * @request GET:/tokens
     * @secure
     */
    tokenControllerListTokens = (params = {}) => this.request({
        path: `/tokens`,
        method: "GET",
        secure: true,
        ...params,
    });
    /**
     * No description
     *
     * @tags Tokens
     * @name TokenControllerDeleteToken
     * @summary Delete a token by its unique ID
     * @request DELETE:/tokens/{id}
     * @secure
     */
    tokenControllerDeleteToken = ({ id }, params = {}) => this.request({
        path: `/tokens/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
    });
}
//# sourceMappingURL=Tokens.js.map